import { memo } from "react";
import { Link } from "../../../Link";

import { ReactComponent as CrossIcon } from "./icons/cross.svg";

type ClearFiltersProps = {
  isVisible: boolean,
  clearFilters: () => void,
  className?: string
};
export default memo<ClearFiltersProps>((
  {
    isVisible,
    clearFilters,
    className,
  }) =>
  isVisible ? (
    <Link
      className={className}
      component="button"
      type="button"
      linkType="s"
      onClick={clearFilters}>
      <CrossIcon width={15} height={15} />Clear all filters
    </Link>
  ) : null,
);
